// @ts-nocheck

import { camelCase as _camelCase, each as _each, isPlainObject as _isPlainObject } from 'lodash';

import pkg from '../../package.json';
import Client, { Target } from '../client';
import { isLibrary } from '../lib/useragent';

const deeplyParseObj = (collection, callback, options, seen = new WeakMap()) => {
  const opts = {
    ...options,
    target: {},
  };

  if (seen.has(collection)) {
    return seen.get(collection);
  }
  seen.set(collection, opts.target);

  const target = opts.target;
  delete opts.target;

  _each(collection, (value, key) => {
    const res = callback(key, value, collection);
    let newVal = res[1];

    if (Array.isArray(newVal) === true) {
      newVal = newVal.map((x) => {
        if (_isPlainObject(x) === true) {
          return deeplyParseObj(x, callback, opts, seen);
        }
        return x;
      });
    } else if (_isPlainObject(newVal)) {
      newVal = deeplyParseObj(newVal, callback, opts, seen);
    }
    target[res[0]] = newVal;
  });
  return target;
};

// FIXME : temporary method: model's properties must be camelCase
const convertToCamelCase = (collection) => {
  let target = undefined;
  if (Array.isArray(collection) === true) {
    target = [];
  } else if (_isPlainObject(collection) === true) {
    target = {};
  } else {
    return collection;
  }

  return deeplyParseObj(collection, (key, value) => [_camelCase(key), value], {
    target,
  });
};

const normalizeEntities = (entities, normalizeFunc) => {
  if (Array.isArray(entities) === true) {
    return entities.map((entity) => {
      const newEntity = { ...entity };
      Object.keys(newEntity).forEach((key) => {
        if (newEntity[key] === null || newEntity === '') {
          console.warn(`normalizeEntities > key: ${key} is invalid. delete it`);
          delete newEntity[key];
        }
        newEntity[key] = normalizeFunc.call(null, key, newEntity[key]);
      });
      return newEntity;
    });
  } else if (typeof entities === 'object') {
    return Object.keys(entities).reduce((prev, curr) => {
      const newEntity = { ...entities[curr] };
      Object.keys(newEntity).forEach((k) => {
        if (newEntity[k] === null || newEntity === '') {
          console.warn(`normalizeEntities > key: ${k} is invalid. delete it`);
          delete newEntity[k];
        }
        newEntity[k] = normalizeFunc.call(null, k, newEntity[k]);
      });
      return { ...prev, [curr]: newEntity };
    }, {});
  }
  return entities;
};

export const pixelToEm = (sizeInPixels) => {
  const baseFontSize = Target.__MOBILE__ ? 15 : 14;
  return sizeInPixels / baseFontSize;
};

export const getVersion = () => {
  let CV = pkg.version;

  if (isLibrary) {
    CV += '-library';
  } else if (Target.__MOBILE__) {
    CV += '-mobile';
    if (Client.embed) {
      CV += '-embedded';
    }
  } else {
    CV += '-desktop';
  }
  return CV;
};

export default {
  normalizeEntities,
  convertToCamelCase,
  getVersion,
};
